import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "label", "alignRight", "variant", "disabled", "onClick", "className"];
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var Pager = function Pager(props) {
  var title = props.title,
    label = props.label,
    alignRight = props.alignRight,
    variant = props.variant,
    disabled = props.disabled,
    onClick = props.onClick,
    className = props.className,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHover = _useState2[0],
    setIsHover = _useState2[1];
  var handleEnter = function handleEnter() {
    return !disabled && setIsHover(true);
  };
  var handleLeave = function handleLeave() {
    return setIsHover(false);
  };
  var isCompactVariant = variant === Pager.VARIANT_COMPACT;
  var wrapperClassesBase = classNames('Pager', 'bg-white', 'border', 'display-flex justify-space-between align-items-center', isHover && 'border-color-highlight', alignRight && 'flex-row-reverse', disabled && 'pointer-events-none', 'cursor-pointer user-select-none');
  var iconClassesBase = classNames('rioplyph', disabled ? 'text-color-light' : 'text-color-darker', isHover && 'text-color-highlight');
  var titleClassesBase = classNames(disabled ? 'text-color-light' : 'text-color-darker', isHover && 'text-color-highlight');

  // The compact version has a slightly different markup and different classes for the
  // individual parts, hence we extend the base classes
  if (isCompactVariant) {
    var wrapperClassesCompact = classNames(wrapperClassesBase, 'rounded-circle', 'padding-y-5 padding-x-15', 'width-auto', className);
    var iconClassesCompact = classNames(iconClassesBase, alignRight ? 'rioglyph-chevron-left margin-right-5' : 'rioglyph-chevron-right margin-left-5', 'text-size-10');
    return /*#__PURE__*/React.createElement("div", _extends({}, remainingProps, {
      className: wrapperClassesCompact,
      onMouseEnter: handleEnter,
      onMouseLeave: handleLeave,
      onClick: onClick
    }), /*#__PURE__*/React.createElement("div", {
      className: "display-flex flex-1-1 flex-column ".concat(alignRight ? 'align-items-end' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: titleClassesBase
    }, title)), /*#__PURE__*/React.createElement("span", {
      className: iconClassesCompact
    }));
  }
  var wrapperClassesFull = classNames(wrapperClassesBase, 'rounded', 'padding-y-15 padding-x-20', 'width-100pct', className);
  var iconClassesFull = classNames(iconClassesBase, alignRight ? 'rioglyph-arrow-left margin-right-10' : 'rioglyph-arrow-right margin-left-10', 'text-size-200pct');
  var titleClassesFull = classNames(titleClassesBase, alignRight && 'text-right', 'text-size-16 text-medium');
  return /*#__PURE__*/React.createElement("div", _extends({}, remainingProps, {
    className: wrapperClassesFull,
    onMouseEnter: handleEnter,
    onMouseLeave: handleLeave,
    onClick: onClick
  }), /*#__PURE__*/React.createElement("div", {
    className: "display-flex flex-1-1 flex-column ".concat(alignRight ? 'align-items-end' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-color-gray line-height-16"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: titleClassesFull
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "text-size-12"
  }, /*#__PURE__*/React.createElement("span", {
    className: iconClassesFull
  })));
};
Pager.VARIANT_FULL = 'full';
Pager.VARIANT_COMPACT = 'compact';
Pager.defaultProps = {
  variant: Pager.VARIANT_FULL,
  alignRight: false,
  disabled: false
};
Pager.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  alignRight: PropTypes.bool,
  variant: PropTypes.oneOf([Pager.VARIANT_FULL, Pager.VARIANT_COMPACT, 'full', 'compact']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string
};
export default Pager;